import React from "react";
import ValidationText from "../../utils/validation/ValidationText.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faSpinner, faTrash } from "@fortawesome/free-solid-svg-icons";
import MultiSelectDropdown from "../dropdown/MultiSelectDropdown.js";

const PurchaseOrderMaterialDetails = (props) => {
    return (
        <div className="innerTable">
            <div className="innerTable-form">
                <div className="item-grp mb-3.5" >
                    <span
                        style={{
                            fontSize: "17px",
                            fontWeight: "700",
                            color: "#4b4b4b"
                        }}
                    >
                        Item details
                    </span>
                    <div
                        className="item-inner-grp mt-[10px] mb-[10px] flex gap-2.5"
                    >
                        <div className="input-grp" style={{ width: "40%" }}>
                            <label>Item Name</label>
                            {props.purchaseOrderDetails.materialType === 'Raw' ?
                                <>
                                    <MultiSelectDropdown
                                        className={` ${props.validStateForMaterials?.error?.rawMaterialId ? "errorInput" : ""}`}
                                        drpIdentity="rawMaterialId"
                                        options={props.rawMaterialList}
                                        closeMenuOnSelect={true}
                                        hideSelectedOptions={false}
                                        onChange={(selected) =>
                                            props.setFilterParameters(selected, "rawMaterialId", "MaterialDetails")
                                        }
                                        allowSelectAll={false}
                                        value={props.rawMaterialList.filter(
                                            (party) =>
                                                party.value === props.purchaseOrderMaterialDetials.rawMaterialId
                                        )}
                                        isDisabled={props.isAllFieldDisable}
                                    />
                                    {/* <ValidationText
                                        error={props.validStateForMaterials.error.rawMaterialId}
                                    /> */}
                                </>
                                :
                                <>
                                    <MultiSelectDropdown
                                        className={` ${props.validStateForMaterials?.error?.packageMaterialId ? "errorInput" : ""}`}
                                        drpIdentity="packageMaterialId"
                                        options={props.packingMaterialDropDownList}
                                        closeMenuOnSelect={true}
                                        hideSelectedOptions={false}
                                        onChange={(selected) =>
                                            props.setFilterParameters(selected, "packageMaterialId", "MaterialDetails")
                                        }
                                        allowSelectAll={false}
                                        value={props.packingMaterialDropDownList.filter(
                                            (party) =>
                                                party.value === props.purchaseOrderMaterialDetials.packageMaterialId
                                        )}
                                        isDisabled={props.isAllFieldDisable}
                                    />
                                    {/* <ValidationText
                                        error={props.validStateForMaterials.error.packageMaterialId}
                                    /> */}
                                </>
                            }
                        </div>
                        <div className="input-grp" style={{ width: "10%" }}>
                            <label>UOM</label>
                            <input className="inputFocus"
                                disabled
                                type="text"
                                id="uom"
                                name="uom"
                                value={props.purchaseOrderMaterialDetials.uom}
                                autoComplete="off"
                                onChange={(event) =>
                                    props.handleChange(event, "uom", "MaterialDetails")
                                }
                            />
                        </div>
                        <div className="input-grp" style={{ width: "12%" }}>
                            <label>Qty.</label>
                            <input
                                className={`inputFocus ${props.validStateForMaterials?.error?.qty ? "errorInput" : ""}`}
                                type="number"
                                id="qty"
                                name="qty"
                                autoComplete="off"
                                value={props.purchaseOrderMaterialDetials.qty}
                                onChange={(event) =>
                                    props.handleChangeForNumber(event, "qty")
                                }
                                disabled={props.isAllFieldDisable}
                            />
                            {/* <ValidationText
                                error={props.validStateForMaterials.error.qty}
                            /> */}
                        </div>
                        <div className="input-grp" style={{ width: "12%" }}>
                            <label>Rate</label>
                            <input
                                className={`inputFocus ${props.validStateForMaterials?.error?.rate ? "errorInput" : ""}`}
                                disabled={props.isAllFieldDisable}
                                type="number"
                                id="rate"
                                name="rate"
                                autoComplete="off"
                                value={props.purchaseOrderMaterialDetials.rate}
                                onChange={(event) =>
                                    props.handleChangeForNumber(event, "rate")
                                }
                            />
                            {/* <ValidationText
                                error={props.validStateForMaterials.error.rate}
                            /> */}
                        </div>
                        <div className="input-grp" style={{ width: "8%" }}>
                            <label>Per</label>
                            <input className="inputFocus"
                                disabled={props.isAllFieldDisable}
                                type="number"
                                id="per"
                                name="per"
                                autoComplete="off"
                                value={props.purchaseOrderMaterialDetials.per}
                                onChange={(event) =>
                                    props.handleChangeForNumber(event, "per")
                                }
                            />
                        </div>
                        <div className="input-grp" style={{ width: "20%" }}>
                            <label>Amount</label>
                            <input
                                type="number"
                                id="amount"
                                name="amount"
                                autoComplete="off"
                                disabled
                                className="inputFocus"
                                value={props.purchaseOrderMaterialDetials.amount}
                                onChange={(event) =>
                                    props.handleChangeForNumber(event, "amount")
                                }
                            />
                        </div>
                    </div>
                    <div className="item-inner-grp flex gap-2.5">
                        <div className="input-grp" style={{ width: "40%" }}>
                            <label>Mfg. By</label>
                            <input className="inputFocus"
                                disabled={props.isAllFieldDisable}
                                type="text"
                                id="make"
                                name="make"
                                autoComplete="off"
                                value={props.purchaseOrderMaterialDetials.make}
                                onChange={(event) =>
                                    props.handleChange(event, "make", "MaterialDetails")
                                }
                            />
                        </div>
                        <div className="input-grp" style={{ width: "60%" }}>
                            <label>Remarks</label>
                            <input className="inputFocus"
                                disabled={props.isAllFieldDisable}
                                type="text"
                                id="remarks"
                                name="remarks"
                                autoComplete="off"
                                value={props.purchaseOrderMaterialDetials.remarks}
                                onChange={(event) =>
                                    props.handleChange(event, "remarks", "MaterialDetails")
                                }
                            />
                        </div>
                    </div>
                </div>
                <div
                    className="btn-grp mb-4">
                    {/* {props.isMaterialDetailsEditing ? (
                        <button
                            className={`add-btn`}
                            onClick={() => props.addEditPurchaserOrderMaterialDetails()}
                            disabled={props.isAllFieldDisable}
                        >
                            Save
                        </button>
                    ) : (
                        <button
                            className={`add-btn`}
                            onClick={() => props.addEditPurchaserOrderMaterialDetails()}
                            disabled={props.isAllFieldDisable}
                        >
                            Add
                        </button>
                    )} */}
                    {props.isMaterialDetailsEditing === true ? (
                        <button
                            className="add-btn"
                            disabled={props.isLoading || props.isAllFieldDisable}
                            onClick={() => props.addEditPurchaserOrderMaterialDetails()}
                        >
                            {props.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Save"}
                        </button>
                    ) : (
                        <button
                            className="add-btn"
                            disabled={props.isLoading || props.isAllFieldDisable}
                            onClick={() => props.addEditPurchaserOrderMaterialDetails()}
                        >
                            {props.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Add"}
                        </button>
                    )}
                    <button
                        className={`cancel-btn`}
                        onClick={() => props.resetMaterialDetails()}
                        disabled={props.isLoading || props.isAllFieldDisable}
                    >
                        Cancel
                    </button>
                    <button
                        className="back-btn"
                        onClick={() => props.closeMaterialDetails()}
                        disabled={props.isLoading}
                    >
                        Back
                    </button>
                </div>
            </div>
            <div className="innerTable-container" style={{ height: "calc(100vh - 485px)" }}>
                <table className="innerList">
                    <thead>
                        <tr>
                            <td style={{ width: "25%" }}>Item Name</td>
                            <td style={{ width: "13%" }}>Quantity</td>
                            <td style={{ width: "10%" }}>Unit</td>
                            <td style={{ width: "9%" }}>Rate</td>
                            <td style={{ width: "6%" }}>Per</td>
                            <td style={{ width: "12%" }}>Amount</td>
                            <td style={{ width: "15%" }}>G.R.N. Entry</td>
                            <td style={{ width: "10%", textAlign: "center" }}>Action</td>
                        </tr>
                    </thead>
                    {props.purchaseOrderMaterialList && props.purchaseOrderMaterialList.length > 0 ?
                        props.purchaseOrderMaterialList.map((details, key) => (
                            <tbody key={key}>
                                <tr>
                                    <td>{props.purchaseOrderDetails.materialType === 'Raw' ? details.rawMaterialId.rmName : details.packageMaterialId.pmName}</td>
                                    <td>{details.qty}</td>
                                    <td>{props.purchaseOrderDetails.materialType === 'Raw' ? details.rawMaterialId.rmUOM : details.packageMaterialId.pmUOM}</td>
                                    <td>{details.rate.toFixed(2)}</td>
                                    <td>{details.per}</td>
                                    <td>{details.amount.toFixed(2)}</td>
                                    <td>{details.isGRNEntryDone ? 'Yes' : 'No'}</td>
                                    <td style={{ textAlign: "center" }}>
                                        <button
                                            className="search-btn"
                                            disabled={props.isAllFieldDisable}
                                            // className={`search-btn ${details.isGRNEntryDone ? 'disable-button' : ''}`}
                                            onClick={() => props.getpurchaseOrderMaterialDetialsById(details)}
                                        >
                                            <FontAwesomeIcon icon={faPen} />
                                        </button>
                                        <button
                                            className="cancel-btn"
                                            disabled={props.isAllFieldDisable}
                                            // className={`cancel-btn ${details.isGRNEntryDone ? 'disable-button' : ''}`}
                                            onClick={() => props.deletepurchaseOrderMaterialDetialsById(details._id)}
                                        >
                                            <FontAwesomeIcon icon={faTrash} />
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        )) :
                        null
                    }
                </table>

            </div>
            {/* <div className="gstAmount-details">
                <p style={{
                    fontSize: "16.5px ",
                    fontWeight: "800 ",
                    color: "rgb(86 86 86)"
                }}>Sub Total :{props.pricing.subTotalAmount ? props.pricing.subTotalAmount.toFixed(2) : 0}</p>
                <p style={{
                    fontSize: "16.5px",
                    fontWeight: "800",
                    color: "rgb(86 86 86)"
                }}>Gst({props.pricing.gstRate ? props.pricing.gstRate : 0}%) : {props.pricing.gstAmount ? props.pricing.gstAmount.toFixed(2) : 0}</p>
                <p style={{
                    fontSize: "16.5px",
                    fontWeight: "800",
                    color: "rgb(86 86 86)"
                }}>Total Amount : {props.pricing.totalAmount ? props.pricing.totalAmount.toFixed(2) : 0}</p>
            </div>
            <div className="btn-grp" style={{ marginTop: "10px" }}>
                <button
                    className="back-btn"
                    onClick={() => props.closeMaterialDetails()}
                >
                    Back
                </button>
            </div> */}



            <div className="item-sections  min-w-[250px] rounded-[10px] max-w-[300px]  mt-3 !p-3  !bg-white " style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px', backgroundColor: "#f5f5f5" }}>
                <p className='!text-center !text-[17px] !font-semibold'>Summary</p>
                <div className="search-grp flex gap-2">
                    <div className="w-[40%] !flex !items-center !text-[14px] !font-medium !text-[#585858] !pt-[8px] ">
                        SUB Total
                    </div>
                    <input
                        className="inputFocus !w-[60%] !bg-transparent !border-t-0 !border-l-0 !border-r-0 !rounded-none !table-cell !align-bottom !pb-[0px] !ml-[1px] !mr-[1px]"
                        type="number"
                        id="subTotal"
                        name="subTotal"
                        autocomplete="off"
                        disabled
                        value={props.pricing.subTotalAmount ? props.pricing.subTotalAmount.toFixed(2) : 0}

                    />
                </div>
                <div className="search-grp flex gap-2">
                    <div className="w-[40%] !flex !items-center !text-[14px] !font-medium !text-[#585858] !pt-[8px] ">
                        GST ({props.pricing.gstRate ? props.pricing.gstRate : 0}%)
                    </div>
                    <input
                        className="inputFocus !w-[60%] !bg-transparent !border-t-0 !border-l-0 !border-r-0 !rounded-none !table-cell !align-bottom !pb-[0px]"
                        type="number"
                        id="crDrNote"
                        name="crDrNote"
                        autocomplete="off"
                        disabled
                        value={props.pricing.gstAmount ? props.pricing.gstAmount.toFixed(2) : 0}

                    />
                </div>

                <div className="search-grp flex gap-2.5 mt-[10px]">
                    <div className="w-[40%] !flex !items-center !text-[15px] !font-medium !text-[rgb(62 62 62)] ">
                        Total Amount
                    </div>
                    <input
                        className="inputFocus w-[60%]"
                        type="number"
                        id="grandTotal"
                        name="grandTotal"
                        autocomplete="off"
                        disabled
                        value={props.pricing.totalAmount ? props.pricing.totalAmount.toFixed(2) : 0}

                    />
                </div>

            </div>
        </div>
    );
};

export default PurchaseOrderMaterialDetails;
